module.exports = __webpack_public_path__ + "img/backyard-planter-wide.c12eb592.jpg";